import { render } from "./ActivityCreate.vue?vue&type=template&id=b873ed68&scoped=true"
import script from "./ActivityCreate.vue?vue&type=script&lang=js"
export * from "./ActivityCreate.vue?vue&type=script&lang=js"

import "./ActivityCreate.vue?vue&type=style&index=0&id=b873ed68&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b873ed68"]])

export default __exports__